/* global femcare, VideoPlayer */

femcare.video.platformVideo.initInlineVideoPlayers = function () {

    this.pauseActivePlayer = function() {
        if (this.activePlayer !== null) {
            this.activePlayer.player.pause();
            this.activePlayer = null;
        }
    };
    
    this.stopActivePlayer = function() {
        if (this.activePlayer !== null) {       
            this.activePlayer.player.stop();
            
            femcare.shared.pubsub.publish('PLATFORM_VIDEO_STOP', {
                player: this.activePlayer.player,
                playerId: this.activePlayer.playerId,
                $trigger: this.activePlayer.$trigger
            });
            
            var shownClass = 'video-player-parent--show';
            $(this.activePlayer.$trigger).find('.' + shownClass).removeClass(shownClass);
            
            this.activePlayer = null;
        }
    };
 
    femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_PLAYS', this.pauseActivePlayer.bind(this));
    femcare.shared.pubsub.subscribe('REQUEST_STOP_ACTIVE_PLAYER', this.stopActivePlayer.bind(this));
    
    this.$inlineVideos.each($.proxy(function (index, element) {

        var $inlineVideo = $(element);
        var $videoPlayerWrapper = $inlineVideo.find('.video-player-parent');

        var $videoPlayer = $('<div class="video-player"></div>');
        $videoPlayer.attr('data-video-aspect-ratio', $inlineVideo.attr('data-video-aspect-ratio'));
        $videoPlayer.attr('data-video-image', $inlineVideo.attr('data-video-image'));
        $videoPlayer.attr('data-video-name', $inlineVideo.attr('data-video-name'));
        $videoPlayer.attr('data-video-url-hls', $inlineVideo.attr('data-video-url-hls'));
        $videoPlayer.attr('data-video-url-progressive', $inlineVideo.attr('data-video-url-progressive'));
        $videoPlayerWrapper.append($videoPlayer);

        var videoPlayer = new VideoPlayer($videoPlayer[0], null, this.videoOptions);
        var playerId = VideoPlayer.getOrCreateId($videoPlayer[0]);
        $inlineVideo.attr('id', playerId);

        $inlineVideo.on('click', '.video__poster', $.proxy(function () {           
            femcare.shared.pubsub.publish('PLATFORM_INLINE_VIDEO_CLICK', {
                player: videoPlayer,
                playerId: playerId,
                $trigger: $inlineVideo
            });

            $videoPlayerWrapper.addClass('video-player-parent--show');

            videoPlayer.play();
        }, this));

        videoPlayer.jwplayer.on('play', function () {
            femcare.shared.pubsub.publish('PLATFORM_INLINE_VIDEO_PLAY', {
                player: videoPlayer,
                playerId: playerId,
                $trigger: $inlineVideo
            });

            if (this.activePlayer !== null && this.activePlayer.playerId !== playerId) {
                this.activePlayer.player.pause();
            }

            this.activePlayer = {
                player: videoPlayer,
                playerId: playerId,
                $trigger: $inlineVideo
            };
            
        }.bind(this));

        videoPlayer.jwplayer.on('pause', function () {
             this.activePlayer = null;
        });

        videoPlayer.jwplayer.on('complete', function () {
            $videoPlayerWrapper.removeClass('video-player-parent--show');
            femcare.shared.pubsub.publish('PLATFORM_INLINE_VIDEO_FINISH', {
                player: videoPlayer,
                playerId: playerId,
                $trigger: $inlineVideo
            });

            this.activePlayer = null;
        });
    }, this));
};